import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components/macro'
import { allData } from 'data/allData'




const Post = () => {

const post = allData;


console.log(allData)

    const Container = styled.div`
     display: flex;
     flex-direction: column;
     width: 100vw;
    /* grid-template-columns: repeat(1, 1fr); */
    /* border: 2px solid red; */
    align-items: center;
   
    
    @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 992px) {
        display: grid;
        grid-template-columns: repeat(3, 1fr)
    }
    `

    const PostContainer = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    /* justify-content: center; */
    width: 95vw;
    /* margin-left: 8px; */
    /* border: 2px solid green; */
    
    @media (min-width: 768px) {
    width: 100%;
    }

    @media (min-width: 992px) {
        width: 100%;
    }
    `
    
    const ImageContainer = styled.section`
    width: 350px;
    height: 350px;
    object-fit: cover;
    /* border: 2px solid red; */
    overflow: hidden;
    margin: 0 0 10px 0;

    @media (min-width: 768px) {
       object-fit: cover;
       overflow: hidden;
        margin: 20px;
    }
    
    
    `
    const Image = styled.img`
    width: 100%;

    @media (min-width: 768px) {
    overflow: hidden;
    }

    @media (min-width: 992px) {
        overflow: hidden;
    }

    &:hover {
        transition: 0.6s ease; 
        opacity: 0.3;
        filter:  invert(100);;
    }
    `

    const Head2 = styled.h2`
    /* font-family: 'Heebo', sans-serif; */
    font-family: "aktiv-grotesk", sans-serif;
    font-weight: 200;
    margin: 10px 0 40px 0;
    width: 350px;
    
    `

    const LinkToStory = styled(Link)`
    cursor: pointer;
    `

    // const ContactWrapper = styled.div`
    // `
    // const LinkToStoryTo = styled(LinkToStory)`
    // font-size: 60px;
    // color: darkcyan;
    // `

    return(

        
            <Container>
            <PostContainer id="section1">
            <ImageContainer>
            <LinkToStory to="/story"><Image src={post[0].url} alt='Vera portrait' /></LinkToStory>
            </ImageContainer>
            <Head2>{post[0].title}</Head2>
            {/* <Head2>I always thought I would be someone. Someday. And here, I am.</Head2> */}
            </PostContainer>

            <PostContainer id="section1">
            <ImageContainer>
            <LinkToStory to="/story">    
            <Image src={post[1].url} alt='Vera on a boat' />
            </LinkToStory>
            </ImageContainer>
            <Head2>{post[1].title}</Head2>
            </PostContainer>
            
            <PostContainer id="section1">
            <ImageContainer>
            <LinkToStory to="/story2">
            <Image src={post[2].url} alt='Vera portrait' />
            </LinkToStory>
            </ImageContainer>
            <Head2>{post[2].title}</Head2>
            </PostContainer>

            <PostContainer id="section2">
            <ImageContainer>
            <LinkToStory to="/story">
            <Image src={post[3].url} alt='Vera portrait' />
            </LinkToStory>
            </ImageContainer>
            <Head2>{post[3].title}</Head2>
            </PostContainer>

            <PostContainer id="section2">
            <ImageContainer>
            <LinkToStory to="/story">
            <Image src={post[4].url} alt='Vera portrait' />
            </LinkToStory>
            </ImageContainer>
            <Head2>{post[4].title}</Head2>
            </PostContainer>

            <PostContainer id="section2">
            <ImageContainer>
            <LinkToStory to="/story">
            <Image src={post[5].url} alt='Vera portrait' />
            </LinkToStory>
            </ImageContainer>
            <Head2>{post[5].title}</Head2>
            </PostContainer>

            <PostContainer id="section2">
            <ImageContainer>
            <LinkToStory to="/story">
            <Image src={post[6].url} alt='Vera portrait' />
            </LinkToStory>
            </ImageContainer>
            <Head2>{post[6].title}</Head2>
            </PostContainer>

            {/* <ContactWrapper>
                <LinkToStoryTo to="/contactme">Know Something?</LinkToStoryTo>
            </ContactWrapper> */}

              {/* {allData.map(post => {
                return(
                    <PostContainer>
                    <ImageContainer>
                    <LinkToStory to="/story"><Image src={post.url} alt="post image" /></LinkToStory>
                    </ImageContainer>
                   <Head2>{allData[0].title}</Head2>
                </PostContainer>
                )
            })} */}

            </Container>
            
        
    )
}

export default Post